import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/fraud-track/headerRightBg.png';
import headerRightBg375 from '../images/fraud-track/headerRightBg375.png';
import ManMagnifyingGlassLock from '../images/fraud-track/ManMagnifyingGlassLock.svg';
import EmailContactSales from '../components/EmailContactSales';
import ProblemSolution from '../components/ProblemSolution';
import FeaturesAndBenefits from '../components/FeaturesAndBenefits';
import FourPersonNodes from '../images/fraud-track/FourPersonNodes.svg';
import GlobeCardData from '../images/fraud-track/GlobeCardData.svg';
import WiredShield from '../images/fraud-track/WiredShield.svg';
import ChessPieces from '../images/fraud-track/ChessPieces.svg';
import WantToSeeHow from '../components/WantToSeeHow';

const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 490px;
	}
`;

const indexHeaderContent =
	<HeaderContent style={{paddingTop: `70px`}}>
		<h1>FraudTrack</h1>
		<p>Strategic fraud<br />prevention and monitoring</p>
		<EmailContactSales />
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 70%;
		margin-top: 2em;
		margin-bottom: 2em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
			margin-bottom: 2em;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 459px;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
		}
	}
`;

const ManMagnifyingGlassLockFigure =
	<HeaderBottomContentFigure>
		<ManMagnifyingGlassLock alt='Woman holding mangnifying glass' className='bottomAligned' />
	</HeaderBottomContentFigure>
;

const Section = styled.section`
	border: none;
`;

const FeaturesAndBenefitsSyle = { marginBottom: '0' };

const FraudTrackPage = (props: any) => {
	return (
	<Layout
		headerSplashBg={headerRightBg}
		headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'100% auto'}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPosition={'right top'}
		headerSplashBgPositionLarge={'center top'}
		headerSplashAlignItemsLarge={'flex-end'}
		headerBottomContent={ManMagnifyingGlassLockFigure}
		headerContentClass={'product'}
		headerContent={indexHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='FraudTrack - Application monitoring'
		metaDescription={'Manage risk and ensure program success with real-time suspicious activity alerts so your team is equipped to catch fraudsters before they hit the system.'}
		skipMoney2020={true}
		splashHeaderMinHeight={'410px'}
		BodyClass={'FraudTrack'}
	>
		<ProblemSolution
			problem={'Fraud is on the rise. Identifying and monitoring fraudulent activity is a time-consuming and costly challenge for financial institutions.'}
			solution={'FraudTrack allows financial institutions to manage risk and care for the well-being of customers with real-time alerts on suspicious activity.'}
		/>
		<FeaturesAndBenefits
			extraStyle={FeaturesAndBenefitsSyle}
			solidBgColor = {'#3ed8c3'}

			leftIcon = {<FourPersonNodes alt='network of four people icon' style={{margin: `0`}} />}
			leftHeading = {'Banking\nnetwork'}
			leftText={'Leverage the banking community by pooling resources to fight fraud together.'}

			middleIcon = {<GlobeCardData alt='Globe, card, and data icon' style={{margin: `11px 0`}} />}
			middleHeading = {'Suspicious\nactivity alerts'}
			middleText = {'Save money by catching and investigating fraudsters before they hit the system.'}

			rightIcon = {<WiredShield alt='Wired Shield icon' style={{margin: `15px 0`}} />}
			rightHeading = {'Rules-based\nanomaly detection'}
			rightText = {'Identify abnormal application patterns to prevent fraudulent accounts.'}
		/>
		<div className='centeredWrapper'>
			<Section className='strategic-fraud row row-flush centered'>
				<article className='col-12 col-md-6 right-on-desktop'>
					<div className='product text-box'>
						<header>
							<h2>Say checkmate to fraud</h2>
						</header>
						<p>Fighting fraud can be an expensive challenge, but it doesn’t have to be. Reduce fraud rates and prevent identity theft through proactive and reactive application scanning.</p><p>But it doesn’t stop there. Strengthen the integrity of our nation's financial institutions. Lock arms with banks in the FraudTrack network to notify each other of the fraudulent activity on a specific customer.</p>

					</div>
				</article>
				<figure className='col-12 col-md-6 left-on-desktop'>
					<ChessPieces alt='Chess Pieces' />
				</figure>
			</Section>
			<WantToSeeHow />
		</div>
	</Layout>
	);
};

export default FraudTrackPage;
